











































import Button from '@/types/components/Button.interface'
import Group from '@/types/Group.interface'
import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import inputsMixin from '@/mixins/inputs-mixin'
export default Vue.extend({
    mixins: [inputsMixin],
    props: {
        //  The selected person
        person: {
            type: Object as PropType<Person>,
            required: true
        },
        //  Determines the type of group we will display
        type: {
            type: String,
            default: null
        }
    },
    computed: {
        actions(): Button[] {
            //  Create our buttons for our menu
            const buttons: Button[] = [
                {
                    icon: this.icon(),
                    text: `Go to ${this.typeText()}`,
                    callback: (group: Group) => this.goToGroup(group)
                },
                {
                    icon: 'bi-trash-fill',
                    text: `Remove from ${this.typeText()}`,
                    disabledPopup: this.operator,
                    callback: (group: Group) => this.removeFromGroupConfirm(group)
                }
            ]

            //  Return our buttons
            return buttons
        },
        filteredGroups(): Group[] {
            //  If type is 'AUTORESPONDERS' we display ONLY autoresponders
            if (this.type === 'AUTORESPONDERS')
                return Array.isArray(this.groups) ? this.filterGroups(true) : null

            //  Else, if type is 'GROUPS' we display ONLY groups
            if (this.type === 'STATIC GROUPS')
                return Array.isArray(this.groups) ? this.filterGroups(false) : this.groups

            //  Else, we will display all of the groups regardless
            return this.groups
        },
        groups(): Group[] {
            return this.$store.getters.personSelectedGroups(this.person.id)
        },
        missingText(): string {
            //  Create a default type
            const type = this.type === 'AUTORESPONDERS' ? 'autoresponders' : 'groups'

            //  Return the message
            return `This contact does not belong to any ${type}`
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        //  Called from PersonProfile; adds a new group to our current list of groups
        addGroup(group: Group): void {
            //  Just add this to our list of groups
            this.groups.push(group)
        },
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        //  Filters our groups to either ONLY return autoresponders or ONLY return non-autoresponders
        filterGroups(flag: boolean): Group[] {
            //  Initialize container for our groups
            const groups = []

            //  Our callback function for returning the groups we want
            const checkGroup = (group: Group, flag: boolean) => {
                return flag ? group.campaign_id : !group.campaign_id
            }

            //  Iterate through each group and filter appropriately
            this.groups.forEach((group: Group) => {
                //  Check if this group is valid to push
                const valid = checkGroup(group, flag)
                //  If set to true, push groups that ARE autoresponders
                if (valid) groups.push(group)
            })

            //  Return our now filtered groups
            return groups
        },
        async getUnsubMsg(group: Group): Promise<string> {
            //  Grab our campaign id from our group
            const campaign_id = group.campaign_id

            //  If the group does NOT have a campaign id, return empty string
            if (!campaign_id) return ''

            //  Get the campaign for this autoresponder IF it is an autoresponder
            const campaign = await this.$store.dispatch('campaignsGet', campaign_id)

            //  If no campaign got returned then we just return an empty string
            if (!campaign) return ''

            //  Return our campaign's unsubscribe messages
            return campaign.unsubscribe_message
        },
        //  Navigates to a group
        goToGroup(group: Group): void {
            //  Navigate to the selected group
            this.$router.push(`/groups/${group.id}`)
        },
        //  The icon we display next to our groups
        icon(): string {
            return this.type === 'AUTORESPONDERS'
                ? 'bi-lightning-fill'
                : 'mdi-account-multiple'
        },
        onclick(action: Button, group: Group): void {
            //  Check if we are disabled
            const disabled = action.disabledPopup

            //  If we are, pop our dialog
            if (disabled) return this.disabledPopup()

            //  Else, just use our callback
            action.callback(group)
        },
        async removeFromGroupConfirm(group: Group): Promise<void> {
            //  Type of group we are removing
            const type = group.campaign_id ? ' <br/> Autoresponder' : 'Group'
            const title = group.campaign_id ? 'Unsubscribe' : 'Remove'

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: `${title} Contact from ${type}`,
                icon: 'mdi-alert',
                color: 'red',
                component: 'group-removal-form',
                closeable: true,
                html: true,
                props: {
                    group: group,
                    unsubMsg: await this.getUnsubMsg(group)
                },
                callback: (result: boolean) => this.removePersonFromGroup(group, result)
            })
        },
        async removePersonFromGroup(group: Group, flag = null): Promise<void> {
            //  Else, remove the person's id from the group
            group.persons_ids.remove(this.person.id)

            //  Attach the flag
            group.flag = flag

            //  Send the update request to the API
            const response = await this.$store.dispatch('groupsPut', group)

            //  If the request failed, do nothing
            if (!response) return

            //  Notify the use of success
            this.$store.commit('appNotificationBarSet', {
                message: `Removed from ${group.campaign_id ? 'autoresponder' : 'group'} ${
                    group.name
                }`
            })
        },
        typeText(): string {
            //  Return the type based on the type of prop type we have
            return this.type === 'AUTORESPONDERS' ? 'Autoresponders' : 'Group'
        }
    }
})
